/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Duration_Too_LongInputs */



/**
* | output |
* | --- |
* | "Event duration cannot exceed 30 seconds for recording." |
*
* @param {Audio_Recorder_Duration_Too_LongInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_duration_too_long = /** @type {((inputs?: Audio_Recorder_Duration_Too_LongInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Duration_Too_LongInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La durée de l'événement ne peut pas dépasser 30 secondes pour l'enregistrement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ereignisdauer darf für die Aufzeichnung 30 Sekunden nicht überschreiten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La durata dell'evento non può superare i 30 secondi per la registrazione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжительность записи события не должна превышать 30 секунд.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La duración del evento no puede exceder los 30 segundos para la grabación.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("录制事件的持续时间不能超过 30 秒。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("録画のイベント継続時間は 30 秒を超えることはできません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्डिंग के लिए इवेंट की अवधि 30 सेकंड से अधिक नहीं हो सकती।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A duração do evento não pode exceder 30 segundos para gravação.")
	return /** @type {LocalizedString} */ ("Event duration cannot exceed 30 seconds for recording.")
});